<template>
  <div id="medicalSearch">
    <!-- BARRA DE BUSCA (srch-hero) — extraída literalmente de busca.html -->
    <div class="srch-hero">
      <div class="srch-fields srch-fields--top">
        <select class="select" v-model="specialty">
          <option value="">Especialidade</option>
          <option
            v-for="opt in specialitiesOptions"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.label }}
          </option>
        </select>

        <div class="srch-input">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <circle cx="11" cy="11" r="7" stroke="#94A3B8"
stroke-width="2"
/>
            <path
              d="M21 21l-4-4"
              stroke="#94A3B8"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          <input
            class="input"
            placeholder="Buscar por nome do profissional de saúde"
            v-model="doctorSearch"
            @keyup.enter="handleSearch"
          />
        </div>

        <button class="btn btn--accent srch-btn" @click="handleSearch">
          Buscar
        </button>
      </div>
    </div>

    <!-- CORPO: FILTROS + RESULTADOS (srch-body) — extraído de busca.html -->
    <div class="srch-body">
      <!-- FILTROS (coluna lateral) -->
      <aside class="card filters">
        <div class="filters-head">
          <h3>Filtros</h3>
          <a @click.prevent="handleClear">Limpar</a>
        </div>

        <div class="filter-group" style="border-top:none;padding-top:0">
          <span class="lbl">Disponibilidade</span>
          <label class="check">
            <input
              type="checkbox"
              v-model="availToday"
              @change="applyDateFilter('today')"
            />
            Hoje
            <!-- <span class="ct">6</span> -->
          </label>
          <label class="check">
            <input
              type="checkbox"
              v-model="availWeek"
              @change="applyDateFilter('week')"
            />
            Esta semana
            <!-- <span class="ct">12</span> -->
          </label>
          <label class="check">
            <input
              type="checkbox"
              v-model="availWeekend"
              @change="applyDateFilter('weekend')"
            />
            Fim de semana
            <!-- <span class="ct">3</span> -->
          </label>
        </div>

        <div class="filter-group">
          <span class="lbl">Faixa de preço</span>
          <div class="chips">
            <span
              class="chip-f"
              :class="priceFilter === 'low' ? 'on' : ''"
              @click="setPriceFilter('low')"
            >
              Até R$ 100
            </span>
            <span
              class="chip-f"
              :class="priceFilter === 'mid' ? 'on' : ''"
              @click="setPriceFilter('mid')"
            >
              R$ 100–150
            </span>
            <span
              class="chip-f"
              :class="priceFilter === 'high' ? 'on' : ''"
              @click="setPriceFilter('high')"
            >
              R$ 150+
            </span>
          </div>
        </div>
      </aside>

      <!-- RESULTADOS -->
      <div class="srch-results">
        <div
          class="results-head"
          style="display:flex;align-items:center;justify-content:space-between;gap:var(--space-4);margin-bottom:var(--space-4);flex-wrap:wrap"
        >
          <div
            class="sort"
            style="display:flex;align-items:center;gap:var(--space-2)"
          >
            <span
              style="font-size:var(--font-size-xs);color:var(--color-gray-400);font-weight:var(--fw-bold)"
            >
              Ordenar por
            </span>
            <select
              class="select"
              v-model="sortBy"
              style="height:38px;font-size:var(--font-size-xs)"
            >
              <option value="rating">Mais bem avaliados</option>
              <option value="price">Menor preço</option>
              <option value="availability">Disponível antes</option>
            </select>
          </div>
        </div>
        <doctors-list
          :specialty="searchQuery.specialty"
          :from-date="searchQuery.from_date"
          :until-date="searchQuery.until_date"
          :doctor-id="searchQuery.doctor_id"
          :sort="sortBy"
          :price-range="priceFilter"
          :doctor-name="searchQuery.doctor_name"
        />
      </div>
    </div>

    <!-- Rodapé compacto (foot-mini) -->
    <footer class="foot-mini">
      <span class="vm-mark">
        <img
          class="vm-logo"
          src="../../assets/images/logo-videomedi.png"
          alt="Videomedi"
        />
      </span>
      <span class="cpy">© 2026 Videomedi · CNPJ 00.000.000/0001-00</span>
      <span class="links">
        <a href="#">Privacidade</a>
        <a href="#">Termos de Uso</a>
        <a href="#">LGPD</a>
        <a href="#">Suporte</a>
      </span>
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DoctorsList from "../Doctors/DoctorsList.vue";

export default {
  name: "MedicalSearch",
  components: {
    DoctorsList
  },
  data() {
    return {
      specialty: this.$route.query.specialty || "",
      doctorSearch: "",
      availToday: false,
      availWeek: false,
      availWeekend: false,
      priceFilter: null,
      sortBy: "rating",
      searchQuery: { ...this.$route.query }
    };
  },
  mounted() {
    this.fetchAllSpecialities();
    // Lê localStorage (mantém comportamento de MedicalSearchFilters)
    const storedSpecialty = localStorage.getItem("specialty");
    const storedFrom = localStorage.getItem("from_date");
    const storedUntil = localStorage.getItem("until_date");
    if (storedSpecialty || storedFrom || storedUntil) {
      const query = {};
      if (storedSpecialty) {
        query.specialty = storedSpecialty;
        this.specialty = storedSpecialty;
      }
      if (storedFrom) {
        query.from_date = storedFrom;
      }
      if (storedUntil) {
        query.until_date = storedUntil;
      }
      if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
        this.$router.replace({ query }).catch(() => {});
      }
    }
  },
  methods: {
    ...mapActions("speciality", ["fetchAllSpecialities"]),

    handleSearch() {
      const query = {};
      if (this.specialty) query.specialty = this.specialty;
      if (this.doctorSearch) query.doctor_name = this.doctorSearch;

      // Preserva datas se já aplicadas pelos checkboxes
      if (this.searchQuery.from_date)
        query.from_date = this.searchQuery.from_date;
      if (this.searchQuery.until_date)
        query.until_date = this.searchQuery.until_date;

      if (Object.keys(query).length) {
        this.$router.push({ query }).catch(() => {});
      } else {
        this.$router.push({ query: { doctors: "all" } }).catch(() => {});
      }
    },

    handleClear() {
      this.specialty = "";
      this.doctorSearch = "";
      this.availToday = false;
      this.availWeek = false;
      this.availWeekend = false;
      this.priceFilter = null;
      localStorage.removeItem("specialty");
      localStorage.removeItem("from_date");
      localStorage.removeItem("until_date");
      localStorage.removeItem("selectedDoctor");
      this.$router.replace({ query: { buscar: "1" } }).catch(() => {});
    },

    applyDateFilter(type) {
      if (type === "today" && this.availToday) {
        this.availWeek = false;
        this.availWeekend = false;
      }
      if (type === "week" && this.availWeek) {
        this.availToday = false;
        this.availWeekend = false;
      }
      if (type === "weekend" && this.availWeekend) {
        this.availToday = false;
        this.availWeek = false;
      }

      const now = new Date();
      let from = null;
      let until = null;

      if (this.availToday) {
        from = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          0,
          0,
          0
        );
        until = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          23,
          59,
          59
        );
      } else if (this.availWeek) {
        const day = now.getDay();
        const monday = new Date(now);
        monday.setDate(now.getDate() - (day === 0 ? 6 : day - 1));
        monday.setHours(0, 0, 0, 0);
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        sunday.setHours(23, 59, 59, 999);
        from = monday;
        until = sunday;
      } else if (this.availWeekend) {
        const day = now.getDay();
        const saturday = new Date(now);
        saturday.setDate(now.getDate() + (6 - day));
        saturday.setHours(0, 0, 0, 0);
        const sunday = new Date(saturday);
        sunday.setDate(saturday.getDate() + 1);
        sunday.setHours(23, 59, 59, 999);
        from = saturday;
        until = sunday;
      }

      const toISO = d => (d ? d.toISOString().slice(0, 16) : undefined);
      const query = { ...this.$route.query };

      if (from && until) {
        query.from_date = toISO(from);
        query.until_date = toISO(until);
      } else {
        delete query.from_date;
        delete query.until_date;
      }

      this.$router.push({ query }).catch(() => {});
    },

    setPriceFilter(range) {
      this.priceFilter = this.priceFilter === range ? null : range;
      // Faixa de preço visual por enquanto (API não suporta filtro de preço)
    }
  },
  computed: {
    ...mapGetters("speciality", ["specialitiesOptions"])
  },
  watch: {
    "$route.query"(newQuery) {
      this.searchQuery = { ...newQuery };
      this.specialty = newQuery.specialty || "";
    }
  }
};
</script>

<style lang="scss" scoped>
.vm-logo {
  display: block;
  height: 22px;
  width: auto;
}

#medicalSearch {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 64px);
}

.srch-fields--top {
  grid-template-columns: 230px 1fr auto;
  max-width: 720px;
  margin-left: auto;
}

.srch-btn {
  height: 50px;
}

@media (max-width: 640px) {
  .srch-hero {
    padding: var(--space-4);
  }

  .srch-fields--top {
    grid-template-columns: 1fr auto;
    max-width: none;
    margin-left: 0;

    .select {
      grid-column: 1 / -1;
    }
  }
}
</style>
